module.exports = "//static.hsappstatic.net/payments-enrollment-embed-lib/static-1.16041/images/StripeLogo.svg"